/* eslint no-shadow: "off", no-param-reassign: ["error", { "props": false }], no-console: "off", quotes: "off" */

import axios from 'axios';
import auth from '../../../common/auth';

export default {
  logoutUserFromAuthorizedPages({ commit }) {
    commit('clearAllData');
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('username');
    sessionStorage.removeItem('jwtToken');
    sessionStorage.removeItem('username');
    commit('setjwtFromStorage', null);
    commit('setUserAuthorized', false);
    window.location.reload();
    this.$router.push('/login');
  },
  sendReOptinPin({ dispatch, commit }, payload) {
    // eslint-disable-next-line
    console.log('Verification Reoptin Pin Process' + payload.pinObject.pin);
    return axios({
      url: 'api/verifyReoptinPin',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        pin: payload.pinObject.pin,
        ti: payload.pinObject.ti,
        ts: payload.pinObject.ts,
      },
    }).then((response) => {
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        commit('setSuccessForReoptinWith2StepVerificationVerified', true);
        commit('setSuccessForReoptinWith2StepVerificationWrongPin', false);
        commit('setSuccessForReoptinWith2StepVerificationBlockedUser', false);
        commit('setSuccessForReoptinWith2StepVerificationServerError', false);
      } else if (response.data.responseEnum === 'WRONG_PIN' || response.data.responseEnum === 'PIN_EXPIRED') {
        commit('setSuccessForReoptinWith2StepVerificationVerified', false);
        commit('setSuccessForReoptinWith2StepVerificationWrongPin', true);
        commit('setSuccessForReoptinWith2StepVerificationBlockedUser', false);
        commit('setSuccessForReoptinWith2StepVerificationServerError', false);
      } else if (response.data.responseEnum === 'BLOCKED_USER') {
        commit('setSuccessForReoptinWith2StepVerificationVerified', false);
        commit('setSuccessForReoptinWith2StepVerificationWrongPin', false);
        commit('setSuccessForReoptinWith2StepVerificationBlockedUser', true);
        commit('setSuccessForReoptinWith2StepVerificationServerError', false);
      } else {
        commit('setSuccessForReoptinWith2StepVerificationVerified', false);
        commit('setSuccessForReoptinWith2StepVerificationWrongPin', false);
        commit('setSuccessForReoptinWith2StepVerificationServerError', true);
        commit('setSuccessForReoptinWith2StepVerificationBlockedUser', false);
      }
    }).catch((error) => {
      dispatch('logoutUserFromAuthorizedPages');
      console.log(`Invoking sendReOptinPin failed with the following error: ${error}`);
    });
  },
  clearNotifications({ dispatch, commit }) {
    return axios({
      url: 'api/clearNotifications',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        const tempNotifications = [];
        commit({ type: 'storeNotifications', notifications: tempNotifications });
      }
    }).catch((error) => {
      dispatch('logoutUserFromAuthorizedPages');
      console.log(`Invoking clearNotifications failed with the following error: ${error}`);
    });
  },
  changeNotificationReadStatus() {
    console.log('changeNotificationReadStatus process: ');
    return axios({
      url: 'api/changeNotificationReadStatus',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    });
  },
  getLastSharedRankDate() {
    return axios({
      url: 'api/getLastSharedRankDate',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    });
  },
  getLastSharedLevel() {
    return axios({
      url: 'api/getLastSharedLevel',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    });
  },
  // eslint-disable-next-line
  giveContent({ dispatch, commit }, payload) {
    console.log('giveContent process: ');
    return axios({
      url: 'api/giveContent',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        action: payload.action,
        userCurrentPoints: payload.points,
      },
    }).catch((error) => {
      dispatch('logoutUserFromAuthorizedPages');
      console.log(`Invoking giveContent failed with the following error: ${error}`);
    });
  },
  // eslint-disable-next-line
  sendNotificationReward({ commit }, payload) {
    return axios({
      url: `api/sendReward?id=${payload.reward}&notificationId=${payload.notif}`,
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    });
  },
  getUserNotifications({ dispatch, commit }) {
    console.log('Get notifications');
    return axios({
      url: 'api/getStoredNotifications',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      // success callback
      commit({ type: 'storeNotifications', notifications: response.data.data });
    }).catch((error) => {
      dispatch('logoutUserFromAuthorizedPages');
      console.log(`Invoking getUserNotifications failed with the following error: ${error}`);
    });
  },
  requestPin({ dispatch, commit }, payload) {
    console.log('Get Pin Process');
    return axios({
      url: 'api/getPin',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        bundleId: payload.value.bundleId,
      },
    }).then((response) => {
      commit({ type: 'setRequestPinResponse', value: response.data.responseEnum });
    }).catch((error) => {
      dispatch('logoutUserFromAuthorizedPages');
      console.log(`Invoking requestPin failed with the following error: ${error}`);
    });
  },
  chargePinCall({ dispatch, commit }, payload) {
    console.log("Invoking chargePinCall");
    return axios({
      url: 'api/charge',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        bundleId: payload.value.bundleId,
        pin: payload.value.pin,
      },
    }).then((response) => {
      commit({ type: 'setChargePinResponse', value: response.data.responseEnum });
    }).catch((error) => {
      dispatch('logoutUserFromAuthorizedPages');
      console.log(`Invoking chargePinCall failed with the following error: ${error}`);
    });
  },
  storedBundlesCall({ dispatch, commit }) {
    return axios({
      url: 'api/getStoreItems',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      // success callback
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        commit({ type: 'setBundles', value: response.data.data });
      }
    }).catch((error) => {
      dispatch('logoutUserFromAuthorizedPages');
      console.log(`Invoking storedBundles failed with the following error: ${error}`);
    });
  },
  setMatchInfo({ dispatch, commit }, payload) {
    commit({ type: 'setGameDetails', details: '' });
    commit({ type: 'setOppDetails', details: '' });
    return axios({
      url: 'api/getMatchHistory',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        duelId: payload.duelId,
      },
    }).then((response) => {
      const gameDetails = response.data.data;
      commit({ type: 'setGameDetails', details: gameDetails });
      const oppDetails = payload;
      commit({ type: 'setOppDetails', details: oppDetails });
    }).catch((error) => {
      dispatch('logoutUserFromAuthorizedPages');
      console.log(`Invoking setMatchInfo failed with the following error: ${error}`);
    });
  },
  storeAvailablePrizeTypes({ state, commit }, userLanguage) {
    return axios({
      url: `api/getPrizeData?lang=${userLanguage}`,
      method: 'GET',
    }).then((response) => {
      // success callback
      // eslint-disable-next-line
      const prizes = response.data.data;
      const types = [];
      /* eslint-disable */
      for (var i = 0; i < prizes.length; i++) {
        types.push(prizes[i].type);
      }
      const carouselPrizes = response.data.data;
      commit({ type: 'setCarouselPrizes', value: carouselPrizes });
      for (var i = 0; i < prizes.length; i++) {
        if (prizes[i].type === state.prizes.WEEKLY) {
          const weeklyPrize = prizes[i];
          commit({ type: 'setWeeklyPrize', value: weeklyPrize });
        } else if (prizes[i].type === state.prizes.DAILY) {
          const dailyPrize = prizes[i];
          commit({ type: 'setDailyPrize', value: dailyPrize });
        } else if (prizes[i].type === state.prizes.MONTHLY) {
          const monthlyPrize = prizes[i];
          commit({ type: 'setMonthlyPrize', value: monthlyPrize });
        } else if (prizes[i].type === state.prizes.GRAND) {
          const grandPrize = prizes[i];
          commit({ type: 'setGrandPrize', value: grandPrize});
        }
      }
      console.log(types);
      /* eslint-enable */
      commit('setAvailablePrizeTypes', types);
    }).catch((error) => {
      console.log(`Invoking storeAvailablePrizetypes failed with the following error: ${error}`);
    });
  },
  storePrizesAndWinners({ dispatch, commit }, payload) {
    return axios({
      url: 'api/getPrizeLeaderboardDetails',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        language: payload.language,
        prizeType: payload.prizeType,
      },
    }).then((response) => {
      const responseData = response.data.data;
      // eslint-disable-next-line
      console.log(responseData);
      if (responseData !== undefined) {
        const prizes = [];
        const winners = [];
        const ranks = [];
        Object.keys(responseData).forEach((key) => {
          if (responseData && Object.prototype.hasOwnProperty.call(responseData, key)) {
            prizes.push({
              activeFrom: (responseData[key]) ? responseData[key].activeFrom : '',
              activeTo: (responseData[key]) ? responseData[key].activeTo : '',
              banner: (responseData[key]) ? responseData[key].banner : '',
              description: (responseData[key]) ? responseData[key].description : '',
              eligibilityCriteria: (responseData[key]) ? responseData[key].eligibilityCriteria : '',
              headline: (responseData[key]) ? responseData[key].headline : '',
              imgUrl: (responseData[key]) ? responseData[key].imgUrl : '',
              type: (responseData[key]) ? responseData[key].type : '',
              lastRefreshed: (responseData[key]) ? responseData[key].lastRefreshed : '',
            });
            winners.push((responseData[key]) ? responseData[key].userRankPointsDTOList : []);
            ranks.push((responseData[key]) ? responseData[key].rankDTO : []);
          }
        });
        if (payload.prizeType === 'DAILY') {
          commit('setDailyPrizeForLeaderboard', prizes);
          commit('setDailyWinnersForLeaderboard', winners);
          commit('setDailyRankForLeaderboard', ranks);
        } else if (payload.prizeType === 'WEEKLY') {
          commit('setWeeklyPrizeForLeaderboard', prizes);
          commit('setWeeklyWinnersForLeaderboard', winners);
          commit('setWeeklyRankForLeaderboard', ranks);
        } else if (payload.prizeType === 'MONTHLY') {
          commit('setMonthlyPrizeForLeaderboard', prizes);
          commit('setMonthlyWinnersForLeaderboard', winners);
          commit('setMonthlyRankForLeaderboard', ranks);
        } else if (payload.prizeType === 'GRAND') {
          commit('setGrandPrizeForLeaderboard', prizes);
          commit('setGrandWinnersForLeaderboard', winners);
          commit('setGrandRankForLeaderboard', ranks);
        }
      }
    }).catch((error) => {
      dispatch('logoutUserFromAuthorizedPages');
      console.log(`Invoking storePrizeAndWinners failed with the following error: ${error}`);
    });
  },
  // eslint-disable-next-line
  resetPassword({ commit, state }, payload) {
    console.log('resetPassword process: ');
    return axios({
      url: 'api/resetUserPassword',
      method: 'POST',
      data: {
        msisdn: payload.msisdn,
        passwordOld: state.hashedPass,
        password: payload.password,
      },
    }).then((response) => {
      console.log(response);
      commit('setHashedPassForForgotPass', null);
    }).catch((error) => {
      console.log(`Invoking resetPassword failed with the following error: ${error}`);
    });
  },
  storeVisitorWinners({ commit, state }, userLanguage) {
    return axios.get(`api/getWinnersData?lang=${userLanguage}`).then((response) => {
      const winners = response.data.data;
      commit({ type: 'setWinners', value: winners });
      const extraArrays = [];
      // deep clone because the object in splice function deletes the attributes from the same memory pool
      for (let i = 0; i < state.visitorWinners.length; i += 1) {
        extraArrays.push(state.visitorWinners[i]);
      }
      if (extraArrays.length > state.numberOfDefaultDisplayWinners) {
        commit('setMoreWinnersButton', true);
        for (let k = state.numberOfDefaultDisplayWinners; k < extraArrays.length; k += 1) {
          extraArrays.splice(k);
        }
      }
      commit({ type: 'setExtraWinners', value: extraArrays });
    }).catch((error) => {
      console.log(`Invoking storeBalanceVisitorWinners failed with the following error: ${error}`);
    });
  },
  // eslint-disable-next-line
  checkCoreResponses({ dispatch, commit }) {
    // eslint-disable-next-line
    if (auth.getJwt()) {
      console.log('checkCoreResponses in common');
      return axios({
        url: 'api/getUserLoginDetails',
        method: 'POST',
        headers: {
          Authorization: auth.getJwt(),
        },
        data: {
          language: localStorage.getItem('locale'),
        },
      }).then((response) => {
        console.log('response.data.responseEnum', response.data.responseEnum);
        if (response.data.responseEnum !== 'OPERATION_SUCCESS') {
          localStorage.removeItem('jwtToken');
          localStorage.removeItem('username');
          sessionStorage.removeItem('jwtToken');
          sessionStorage.removeItem('username');
          commit({ type: 'setjwtFromStorage', jwt: null });
          commit('setUserAuthorized', false);
          // eslint-disable-next-line
          console.log('Core is down');
          return 'CORE_IS_DOWN';
        } return null;
      }).catch((error) => {
        dispatch('logoutUserFromAuthorizedPages');
        console.log(`Invoking checkCoreResponses failed with the following error: ${error}`);
      });
    }
  },
  // eslint-disable-next-line
  getUserLoginDetails({ dispatch, commit, state }) {
    console.log('getUserLoginDetails call');
    if (auth.getJwt()) {
      console.log('getUserLoginDetails call with correct jwt');
      commit('setjwtFromStorage', auth.getJwt());
      return axios({
        url: 'api/getUserLoginDetails',
        method: 'POST',
        headers: {
          Authorization: auth.getJwt(),
        },
        data: {
          language: localStorage.getItem('locale'),
        },
        // eslint-disable-next-line
      }).then((response) => {
        console.log('response.data.responseEnum', response.data.responseEnum);
        if (response.data.responseEnum === 'OPERATION_SUCCESS') {
          // themes
          commit('storeThemes', response.data.data.themeDTOS);
          // history
          commit({ type: 'storeGameHistoryData', value: response.data.data.userGameHistoryDTO });
          if (state.gameHistoryData.length !== 0) {
            console.log('GAMEHISTORY TRUE');
            commit('setShowHistory', true);
          } else {
            console.log('GAMEHISTORY FALSE');
            commit('setShowHistory', false);
          }
          // userDetails
          const userDetails = response.data.data.userDTO;
          console.log('inside userDetails:', userDetails);
          commit('common/storeUserDetails', userDetails, { root: true });
          console.log('getUserDetails process from DB');
          return axios({
            url: 'api/userDetails',
            method: 'GET',
            headers: {
              Authorization: auth.getJwt(),
            },
            // eslint-disable-next-line
          }).then((responseUserDetails) => {
            if (responseUserDetails.data.responseEnum === 'OPERATION_SUCCESS') {
              const userDetails = responseUserDetails.data.data;
              // eslint-disable-next-line
              console.log('-------------userDetails From userDetails---------------------------: ' + userDetails.displayAvatar);
              commit('common/storeUserDetailsFromDuel', userDetails, { root: true });
              console.log('TRUE in common');
              return axios({
                url: 'publicapi/getMultiOperatorConfigProperties',
                method: 'GET',
                params: {
                  operatorKey: userDetails.operator || '',
                },
              }).then((response) => {
                commit('common/setReoptinOptoutConfig', { value: response.data.data.reoptinAndOptoutConfig }, { root: true });
                commit('common/updateOptOutFromHome', { value: response.data.data.showOptOutPhase }, { root: true });
                commit('common/updateSubAndUnsubViaSMS', { value: response.data.data.subAndUnsubViaSMS }, { root: true });
                commit('common/updateMultiOperatorOrdinal', { value: response.data.data.multiOperatorOrdinal }, { root: true });
                commit('common/setHideStore', { value: response.data.data.hideStore }, { root: true });
                commit('common/setDisplayPrice', { value: response.data.data.displayPrice }, { root: true });
                commit('common/updatePinForBundles', { value: response.data.data.pinForBundles }, { root: true });
                commit('common/storePurchaseViaSMS', { value: response.data.data.purchaseViaSMS }, { root: true });
              }).catch((error) => {
                console.log(`Invoking publicapi/getMultiOperatorConfigProperties failed with the following error: ${error}`);
              });
              // sessionStorage.setItem('visitorCurrentTabPath', '/home');
            }
          }).catch((error) => {
            console.log(`Invoking userDetails failed with the following error: ${error}`);
          });
          // eslint-disable-next-line
        } else {
          localStorage.removeItem('jwtToken');
          localStorage.removeItem('username');
          sessionStorage.removeItem('jwtToken');
          sessionStorage.removeItem('username');
          commit({ type: 'setjwtFromStorage', jwt: null });
          commit('setUserAuthorized', false);
        }
      }).catch((error) => {
        dispatch('logoutUserFromAuthorizedPages');
        console.log(`Invoking getUserLoginDetails failed with the following error: ${error}`);
      });
    }
  },
  storeLoginInfo({ commit }, payload) {
    if (payload.rememberMeParameter) {
      localStorage.setItem('jwtToken', payload.token);
      localStorage.setItem('username', payload.username);
      commit({ type: 'setjwtFromStorage', jwt: localStorage.getItem('jwtToken') });
    } else {
      sessionStorage.setItem('username', payload.username);
      sessionStorage.setItem('jwtToken', payload.token);
      commit('setjwtFromStorage', sessionStorage.getItem('jwtToken'));
    }
    commit('setUserAuthorized', true);
  },
  callForAuthorizationFB({ commit }, payload) {
    // eslint-disable-next-line
    console.log('Authorization Process with FB TOKEN');
    return axios({
      url: '/authFb',
      method: 'POST',
      data: {
        accessToken: payload.accessToken,
        msisdn: payload.msisdn,
      },
    }).then((response) => {
      // get body data
      const TokenObject = response.data;
      const tokenExists = true;
      if (tokenExists) {
        return axios({
          url: '/user',
          method: 'GET',
          headers: {
            Authorization: TokenObject.token,
          },
        }).then((responseUser) => {
          // get body data
          console.log(`Invoking user via FB with the following username: ${responseUser.data.username}`);
          // if (payload.rememberMe) {
          localStorage.setItem('jwtToken', TokenObject.token);
          localStorage.setItem('username', responseUser.data.username);
          commit({ type: 'setjwtFromStorage', jwt: localStorage.getItem('jwtToken') });
          commit('setUserAuthorized', true);
          // } else {
          //   sessionStorage.setItem('username', responseUser.data.username);
          //   sessionStorage.setItem('jwtToken', TokenObject.token);
          //   commit({ type: 'setjwtFromStorage', jwt: sessionStorage.getItem('jwtToken') });
          // }
          // commit('setUserAuthorized', true);
        }, (responseUser) => {
          // error callback
          console.log(responseUser);
          commit('setUserAuthorized', false);
          return null;
        });
      }
      return null;
    }, (response) => {
      // error callback
      console.log(response);
      console.log('error callback');
      commit('setUserAuthorized', false);
      return null;
    });
  },
  callForAuthorization({ commit }, {
    username, password, operator, rememberMe, cid, fbReferral, clickId, refUrl, campaignId, publisherId,
  }) {
    console.log('AUTHORIZATION Process');
    return axios.post('/auth', {
      username,
      password,
      operator,
      rememberMe,
      correlationId: cid,
      fbReferral,
      clickId,
      refUrl,
      campaignId,
      publisherId,
    }).then((response) => {
      // get body data
      // console.log(`Invoking /callForAuthorization failed with the following error: ${response}`);
      if (response.data === 'MSISDN_INVALID' || response.data === 'PIN_EXPIRED' || response.data === 'WRONG_PIN') {
        // SIMPLE_WITH_WEB_REGISTRATION cases
        sessionStorage.setItem('operatorError', 'false');
        return response.data;
      } else if (response.data === 'MSISDN_NOT_EXIST') {
        sessionStorage.setItem('operatorError', 'true');
        return response.data;
      }
      sessionStorage.setItem('operatorError', 'false');
      const TokenObject = response.data;
      return axios({
        url: '/user',
        method: 'GET',
        headers: {
          Authorization: TokenObject.token,
        },
      }).then((responseUser) => {
        // get body data
        console.log(`Invoking user with the following username: ${responseUser.data.username}`);
        if (rememberMe) {
          localStorage.setItem('jwtToken', TokenObject.token);
          localStorage.setItem('username', responseUser.data.username);
          commit('setjwtFromStorage', localStorage.getItem('jwtToken'));
        } else {
          sessionStorage.setItem('username', responseUser.data.username);
          sessionStorage.setItem('jwtToken', TokenObject.token);
          commit('setjwtFromStorage', sessionStorage.getItem('jwtToken'));
        }
        commit('setUserAuthorized', true);
      }).catch((error) => {
        commit('setUserAuthorized', false);
        console.log(`Invoking callForAuthorization failed with the following error: ${error}`);
      });
    }).catch((error) => {
      commit('setUserAuthorized', false);
      console.log(`Invoking callForAuthorization failed with the following error: ${error}`);
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/profile/actions.js